module.exports = "<h1 id=\"选择器--m-picker\">选择器  m-picker</h1>\n";